export const useMouse = (elementRef, { onMouseMove, onMouseUp, }) => {
    let isGrabbing = false;
    let isMouseDown = false;
    let isMouseMoved = false;
    let mouseDownX = 0;
    let previousX = 0;
    const handleMouseDown = (event) => {
        if (elementRef.current) {
            isGrabbing = true;
        }
        isMouseDown = event.buttons > 0;
        mouseDownX = event.clientX;
        previousX = event.clientX;
    };
    const handleMouseMove = (event) => {
        if (isMouseDown && event.buttons > 0) {
            onMouseMove(event.clientX - mouseDownX, 0, event.clientX - previousX);
            isMouseMoved = true;
            previousX = event.clientX;
        }
    };
    const handleMouseUp = (event) => {
        if (elementRef.current) {
            isGrabbing = false;
        }
        if (isMouseDown && isMouseMoved) {
            onMouseUp(event.clientX - mouseDownX, 0, event);
        }
        isMouseDown = false;
        isMouseMoved = false;
    };
    return {
        onMouseDown: (event) => handleMouseDown(event),
        onMouseMove: (event) => handleMouseMove(event),
        onMouseUpCapture: (event) => handleMouseUp(event),
        onMouseLeave: (event) => handleMouseUp(event),
        isGrabbing,
    };
};
